import axios from "axios";
import { API_BASE } from "./mailService";

const API_URL = `${API_BASE}/api/seasonalDiscounts/active`;

export const getActiveDiscount = async () => {
  try {
    const res = await axios.get(API_URL);
    const data = res.data;

    if (!data || typeof data !== "object") {
      return null;
    }

    // Support both camelCase (name, value, isPercentage) and PascalCase (Name, Value, IsPercentage)
    const name = data.name ?? data.Name;
    const value = data.value ?? data.Value;
    const isPercentage = data.isPercentage ?? data.IsPercentage;

    if (name && value !== undefined) {
      return { name, value, isPercentage };
    }

    return null;
  } catch {
    return null;
  }
};
